import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
export default {
  mixins: [baseCrudMixin],
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  data: () => ({
    entity: 'StandardUser',
    returnTo: 'StandardUsers'
  }),
  created() {
    this.$store.dispatch('company/getItems');
    this.$store.dispatch('domain/getItems');
    this.$store.dispatch('role/getItems');
    this.$store.dispatch('workshop/getItems');
  },
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
